import { HttpParams } from "@angular/common/http";
import { computed, Signal, untracked } from "@angular/core";
import { MethodLoading, QueryParam } from "../store-types.model";

export function queryParamToHttp(query?: QueryParam) {
  if (query) {
    const cleaned: QueryParam = {};
    for (const [key, value] of Object.entries(query)) {
      if (value != null) {
        cleaned[key] = value;
      }
    }
    return Object.keys(cleaned).length
      ? new HttpParams().appendAll(cleaned)
      : new HttpParams();
  }
  return new HttpParams();
}

export function mapSignalArray<T, U>(
  signals: Signal<Signal<T>[]>,
  mapper: (e: T) => U,
): Signal<Signal<U>[]> {
  return computed<Signal<U>[]>(() => {
    return signals().map((signal) => {
      return computed<U>(() => {
        return mapper(signal());
      });
    });
  });
}

export function initMethodsStatus<T>(cls, value: boolean): MethodLoading<T> {
  const result: any = {};
  const methods: Array<keyof T> = Object.getOwnPropertyNames(cls).filter(
    (n) => typeof cls[n] === "function" && n !== "constructor",
  ) as Array<keyof T>;
  methods.forEach((key) => {
    result[(key as string) + "Loading"] = value;
  });
  return result as MethodLoading<T>;
}

export function UpdateStatus(
  target: any,
  propertyName: string,
  descriptor: PropertyDescriptor,
) {
  const originalMethod = descriptor.value;
  descriptor.value = async function (...args: any[]) {
    untracked(() =>
      this.store.getWritableState()[propertyName + "Loading"]?.set(true),
    );
    let result;
    try {
      result = await originalMethod.apply(this, args);
    } catch (e) {
      if (
        e?.message !== "no elements in sequence" &&
        e?.name !== "EmptyError"
      ) {
        console.error("error in promise. Ex. call WS");
        console.error(e);
        throw e;
      }
    } finally {
      untracked(() =>
        this.store.getWritableState()[propertyName + "Loading"]?.set(false),
      );
    }
    return result;
  };
  return descriptor;
}

/**
 * Decorator for marking a method as his signals untracked.
 */
export function Untrack(
  target: any,
  propertyName: string,
  descriptor: PropertyDescriptor,
) {
  const originalMethod = descriptor.value;
  descriptor.value = function (...args: any[]) {
    const errorTrack = new Error();
    return untracked(() => {
      const result = originalMethod.apply(this, args);
      return result?.catch
        ? result.catch((e) => {
            throw e;
          })
        : result;
    });
  };
  return descriptor;
}
